import { TrMetricsService } from "services/TrMetricsService";
import qs from "qs";

export async function firePageReferredEvent() {
  const referrerHostname = document.referrer.split("?")[0];
  const isExternal =
    referrerHostname.length > 0 && !referrerHostname.match(/taskrabbit\./);

  if (
    isExternal ||
    (await TrMetricsService.defaultEventData()).marketing_referrer.length > 0
  ) {
    const queryMap = qs.parse(document.location.search, {
      ignoreQueryPrefix: true,
    });

    TrMetricsService.fire("page_referred", queryMap);
  }
}
